import { NgModule } from '@angular/core';
import { SelectedUserRolesToRolePipe } from './selected-user-roles-to-role.pipe';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    SelectedUserRolesToRolePipe
  ],
  exports: [
    SelectedUserRolesToRolePipe
  ]
})
export class SelectedUserRolesToRolePipeModule { }
